<div id="email-body-content" class="email-bottom">
    <p contenteditable="true">
        <span class="email-content">{{appName}} will have a Production Deployment at 
            <strong>[</strong>HH:MM AM/PM<strong>]</strong> on {{releaseDate}}.
        </span>
    </p>
    <p>
        <span class="email-content" contenteditable="true">The Release Notes for this deployment can be found on the
            online release notes web application 
        </span>
        <a contenteditable="false" href="https://webapps.harriscountytx.gov/ReleaseNotes/applications" target="_blank">here</a>
        <span class="email-content" contenteditable="true">.</span>
    </p>
    <p>
        <span class="email-content" contenteditable="true">If you encounter any issues following the deployment, please
            contact 
        </span>
        <a contenteditable="false" href="mailto:HelpDesk@HarrisCountyTx.Gov">HelpDesk@HarrisCountyTx.Gov</a>
        <span
            class="email-content" contenteditable="true">. If there are any questions and/or concerns please let me
            know.
        </span>
    </p>
    <p contenteditable="true">
        <span class="email-content">Thank You.</span>
    </p>
    <email-sig></email-sig>
</div>